const practicalIds = document.querySelectorAll('.practical-info');
for (x in practicalIds) {
    let practicalId = practicalIds[x].id;
    const togglePractical = document.getElementById('togglePractical' + practicalId);
    const practical = document.getElementById('practicalText' + practicalId);
    const show = document.querySelector('.show' + practicalId);
    const hide = document.querySelector('.hide' + practicalId);

    if (practical) {
        togglePractical.addEventListener('click', function () {
            practical.classList.toggle('collapsed');
            show.classList.toggle('collapsed');
            hide.classList.toggle('collapsed');
        });
    }
}
